module.exports = __webpack_public_path__ + "b499842b3f37694958e7623f9635c9f8.png";